import { MantineThemeOverride } from '@mantine/core';

export type MediaQueryTheme = NonNullable<MantineThemeOverride['components']>['MediaQuery'];

export const MediaQuery: MediaQueryTheme = {
  // todo: define
};
